import { GET_PERSONAL_SUMMARY } from './types';

export const getPersonalSummary = () => {
  return {
    type: GET_PERSONAL_SUMMARY,
  };
};
